import logoLight from "../../assets/images/logo-light.png";
import logoDark from "../../assets/images/logo-dark.png";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

type TProps = {
  alt?: string;
  forceTheme?: string;
  width?: number;
  objectFit?: string;
};
export const AppLogo: React.FC<TProps> = ({
  alt = "TheQ App - Logo",
  forceTheme,
  width = 100,
  objectFit = "contain",
}) => {
  const layoutModeType = useSelector(
    (state: { Layout: { layoutModeType: string } }) =>
      state.Layout.layoutModeType,
  );

  return (
    <img
      src={
        forceTheme
          ? forceTheme === "dark"
            ? logoDark
            : logoLight
          : layoutModeType === "dark"
            ? logoDark
            : logoLight
      }
      alt={alt}
      width={width}
      style={{ objectFit: objectFit as any }}
    />
  );
};
